import { render, staticRenderFns } from "./RecipePatient.vue?vue&type=template&id=394fcd26&scoped=true"
import script from "./RecipePatient.vue?vue&type=script&lang=js"
export * from "./RecipePatient.vue?vue&type=script&lang=js"
import style0 from "./RecipePatient.vue?vue&type=style&index=0&id=394fcd26&prod&lang=scss&scoped=true"
import style1 from "./RecipePatient.vue?vue&type=style&index=1&id=394fcd26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394fcd26",
  null
  
)

export default component.exports